import { Button, ButtonGroup } from 'react-bootstrap';
import { ConfigIconFontSize, ConfigCard, TBElementItens } from '../../Component/Commons';
import { CardMain, SizeViewSelector, Title, Guardar, ButtonColor, TitleCard, CardConfig, RowConfig, AddItens, ButtonConfig } from '../../Component';
import { State, iten } from './index'
import { ConfigIten } from './Itens/Config';
interface Props {
    save: () => void
    iten: iten;
    title: string;
    config: State;
    setTitle: (d: string) => void;
    setConfig: (d: any) => void,
    setIten: (d: Partial<iten>) => void
    itenUp: (d: number) => void
    itenDown: (d: number) => void
    addIten: () => void
    removeItem: (d: number) => void
}
export function Config({ save, title, config, setTitle, setConfig, setIten, iten, itenUp, itenDown, addIten, removeItem }: Props) {
    const { size, color, orientation, itens: { length } } = config;
    const { back } = iten;
    return <CardMain>
        <Guardar guardar={save} />
        <CardConfig width="250px">
            <RowConfig >
                <Title setData={setTitle} title={title} width='204px' />
                <AddItens tip='AGREGAR UNA CARTA' add={addIten} />
            </RowConfig>
            <RowConfig top={2}>
                <ButtonColor tip='COLOR DETRAS DE LAS CARTAS' className='ml-1' setData={color => setConfig({ color })} color={color}>
                    <i className="fas fa-paint-roller"></i>
                </ButtonColor>
                <ConfigCard config={config} setConfig={setConfig} />
            </RowConfig>
            <div className='mt-2' style={{ height: '24' }}></div>
            <TitleCard>CONFIGURACION GENERAL</TitleCard>
        </CardConfig>
        <CardConfig width="132px">
            <ConfigIconFontSize max={9} step={.1} min={3} config={config} setConfig={setConfig}>
                <ButtonGroup>
                    <Button data-tip='COLOCAR ICONO EN EL CENTRO' size='sm' active={orientation === ''} style={{ width: 32, height: 24 }} onClick={() => setConfig({ orientation: '' })} variant='outline-dark'>
                        <i className='fas fa-compress-alt' style={{ transform: 'rotate(45deg)' }} />
                    </Button>
                    <ButtonConfig tip='COLOCAR ICONO EN LOS BORDES' active={orientation === 'reverse'} action={() => setConfig({ orientation: 'reverse' })} icon='fas fa-arrows-h' />
                </ButtonGroup>
            </ConfigIconFontSize>
            <TitleCard>CONFIGURACION DE ICONOS</TitleCard>
        </CardConfig>
        <ConfigIten cont={length} config={config} iten={iten} addItem={addIten}
            setConfig={setIten} itenUp={itenUp} itenDown={itenDown} removeItem={removeItem} />
        <TBElementItens back={back} setBack={back => setIten({ back })} alfaBack={true} />
        <SizeViewSelector setSize={(size) => setConfig({ size })} size={size} />
    </CardMain >
}